<ng-container *ngrxLet="debugging$ as debugging">
  @if (debugging) {
    <details>
      <summary>{{ name }} model</summary>
      <!--    <ngx-json-viewer [json]="model"></ngx-json-viewer>-->
      <pre>{{ model?.constructor?.name }}</pre>
      <pre>{{ toJson(model) }}</pre>
    </details>
  }
</ng-container>
